/** @jsx h */
import { UIPlugin } from '@uppy/core'
import { h } from 'preact'
import $ from 'jquery'

export default class FileListPlugin extends UIPlugin {
  constructor(uppy, opts) {
    super(uppy, opts)

    const defaultOpts = {
      locale: {
        error: 'Error',
        attachments: 'Attachments'
      }
    }

    this.id = this.opts.id || 'FileListPlugin'
    this.type = 'filelist'
    this.opts = Object.assign({}, defaultOpts, opts)
    this.render = this.render.bind(this)
  }

  bytesToSize(bytes) {
    const sizes = ['bytes', 'KB', 'MB', 'GB', 'TB']
    if (bytes === 0) return '0'
    const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), sizes.length - 1)
    if (i === 0) return `${bytes} ${sizes[i]}`
    return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
  }

  removeFile(event, id) {
    event.preventDefault()
    const file = this.uppy.getFile(id)
    const token = $('meta[name="csrf-token"]').attr('content')
    if (file && file.meta && file.meta.delete_url) {
      $.post(file.meta.delete_url + (token ? '&security_token=' + token : ''))
      this.uppy.removeFile(file.id)
    }
  }

  render(state) {
    const files = this.uppy.getFiles()

    return <div class={files.length > 0 ? 'bordered-section my-3': 'd-none bordered-section my-3'}>
      <table role="presentation" class="table table-striped table-files rounded w-100">
        <thead>
        <tr>
          <th colSpan="4">{this.opts.locale.attachments}</th>
        </tr>
        </thead>
        <tbody class="files">
        {files.map(file => <tr key={'filelist_' + this.id + '_' + file.id}>
          <td className="name w-50">{file.name}</td>
          <td className="size" width="150">{this.bytesToSize(file.size)}</td>
          <td>
            {file.error ? <div className="error">
              <span className="badge badge-styled bg-danger">{this.opts.locale.error}</span> <span>{file.error.toString()}</span>
            </div> : ''}
            {file.progress && !file.progress.uploadComplete && !file.error ? <div
              className="progress progress-success progress-striped active" role="progressbar" aria-valuemin="0"
              aria-valuemax="100" aria-valuenow="0"
            >
              <div className="progress-bar" style={{width: file.progress.percentage + '%'}}></div>
            </div> : ''}
            <div className="start" width="90"></div>
          </td>
          <td className="cancel" width="90" align="right">
            {file.progress.uploadComplete ? <>
              <button
                className="btn btn-warning btn-sm"
                onClick={e => this.removeFile(e, file.id)}
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
              <input type="hidden" name="asyncattachment[]" value={file.meta.hash} />
            </> : ''}
          </td>
        </tr>)}
        </tbody>
      </table>
    </div>
  }

  install() {
    const {target} = this.opts
    if (target) {
      this.mount(target, this)
    }
  }

  uninstall() {
    this.unmount()
  }
}
